export default __webpack_public_path__ + "static/media/prediction_control_func.7a043178.png";